const STORAGE_KEY = 'bsm.notebookDraftLifetimeSave.v1';

function readIds(): Set<string> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return new Set();
    const arr = JSON.parse(raw) as unknown;
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x): x is string => typeof x === 'string' && x.length > 0));
  } catch {
    return new Set();
  }
}

function writeIds(ids: Set<string>) {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(ids)));
  } catch {
    /* quota / private mode */
  }
}

/** Call after an explicit Save or any persist that should keep the draft even if later reverted to empty. */
export function markNotebookDraftLifetimeSave(notebookId: string): void {
  if (!notebookId) return;
  const s = readIds();
  s.add(notebookId);
  writeIds(s);
}

export function notebookHadDraftLifetimeSave(notebookId: string): boolean {
  if (!notebookId) return false;
  return readIds().has(notebookId);
}

export function clearNotebookDraftLifetimeSave(notebookId: string): void {
  if (!notebookId) return;
  const s = readIds();
  if (!s.delete(notebookId)) return;
  writeIds(s);
}
